import { authConsts } from "../store/types/auth";
export function handleSessionError(
  dispatch: Function,
  error: string,
  errorAction: any
) {
  if (error === "Użytkownik nie jest zalogowany.")
    dispatch({
      type: authConsts.SESSION_ERROR
    });
  else dispatch(errorAction);
}
